import React from 'react';
import block from 'propmods';
import Link from '../Link/Link';

import './QuestionLink.scss';

const b = block('QuestionLink');

interface Props {
    url?: string;
    onClick?: () => void;
}

export const QuestionLink: React.FC<Props> = ({ url, onClick }) => {
    const content = '?';

    return (
        <span {...b()} onClick={onClick}>
            {url ? (
                <Link to={url} target="_blank">
                    {content}
                </Link>
            ) : (
                <div {...b('button')}>{content}</div>
            )}
        </span>
    );
};
